const {loadScript, loadStyle} = require('./util/loadDependencies');
require('./util/foreach-polyfill');
// require('./util/ga-dev-fallback');

// Autocomplete
export default (jsBasePath) => jQuery(($) => {
	const triggerSearchSuggestions = () => {
		var xhr;
		var suggestionsSource = carleton_advance__high_ed_lookup.url;
		var wp_nonce = carleton_advance__high_ed_lookup.nonce;
		var wp_action = carleton_advance__high_ed_lookup.action;
		var lookups = $('.carleton-advance--high-ed-lookup');

		lookups.each((idx) => {
			[
				{
					selector: lookups[idx],
					menuClass: 'carleton-advance--high-ed-lookup__results',
				},
			].forEach((args) => {
				$(args.selector).focus(() => {
					$(this).select();
				});
				new autoComplete({
					selector: args.selector,
					menuClass: args.menuClass,
					source: function (term, response) {
						try {
							xhr.abort();
						} catch (e) {
						}
						xhr = $.getJSON(suggestionsSource,
							{
								partial: term,
								action: wp_action,
								nonce: wp_nonce
							},
							function (data) {
								response(data.data || [{'noresults': true}]);
							}
						);
					},
					renderItem: function (item, search) {
						// escape special characters
						search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
						var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
						if (item.noresults) {
							return '<div class="autocomplete-suggestion"><b>' + search + '</b> (not found)</div>';
						}

						var returnString = item.label.replace(re, "<b>$1</b>");
						var location = [];
						if (item.city) location.push(item.city.replace(re, "<b>$1</b>"));
						if (item.state) location.push(item.state.replace(re, "<b>$1</b>"));
						if (item.country) location.push(item.country.replace(re, "<b>$1</b>"));
						if (location.length) returnString += ` (${location.join(', ')})`;

						return `<div class="autocomplete-suggestion" data-code="${item.code.replace(/"/g, '&quot;')}" data-val="${item.label.replace(/"/g, '&quot;')}" data-label="${returnString.replace(/"/g, '&quot;').replace(/<\/?b>/g, '')}">${returnString}</div>`;
					},
					onSelect: function (e, term, item) {
						if (item.getAttribute('data-code').length) {
							e.preventDefault();
							var code = item.getAttribute('data-code');
							$(this.selector).val(item.getAttribute('data-label'));
							var input_id = $(this.selector).attr('id');
							var code_id = input_id.replace('education_institution', 'education_institution_code');
							$(`#${code_id}`).val(code);

							return false;
						}
					}
				});
			});
		});
	}

	loadScript(`${jsBasePath}./autoComplete/auto-complete.min.js`, triggerSearchSuggestions);
});
